import faker from '@faker-js/faker';
import {TUUID} from '@/types';
import loopMap from 'mn-utils/loopMap';
import {COUNTRIES} from '../../../constants/countries';
import {TListItem} from './types';

export const getInvoiceList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getInvoiceDetails();
  });
};

export const getInvoiceDetails = (): TListItem => {
  const countries = COUNTRIES.reduce((acc: TUUID[], country) => {
    acc.push(country.id);
    return acc;
  }, []);

  const statuses = ['initiated', 'pending', 'completed', 'failed'];
  return {
    id: faker.datatype.uuid(),
    fiat_code: faker.finance.currencyCode(),
    amount: faker.finance.amount(1000, 10000, 2),
    created_at: faker.date.recent().toISOString(),
    status: (faker.helpers as any).arrayElement(statuses),
    bank_name: faker.name.findName(),
    iban: faker.finance.iban(),
    ...(faker.datatype.boolean() && {description: faker.lorem.lines()}),
    ...(faker.datatype.boolean() && {swift_code: faker.finance.currencyCode()}),
    ...(faker.datatype.boolean() && {routing_code: faker.finance.iban()}),
    ...(faker.datatype.boolean() && {country: (faker.helpers as any).arrayElement(countries)}),
  } as TListItem;
};
